import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ConfirmModal from './ConfirmModal';
import { useAuth } from '../context/AuthContext';

export default function Production({ setPage }) {
  const { user } = useAuth();
  const [formulas, setFormulas] = useState([]);
  const [formulaId, setFormulaId] = useState('');
  const [qtyPlanned, setQtyPlanned] = useState('');
  const [qtyActual, setQtyActual] = useState('');
  const [notes, setNotes] = useState('');
  const [calc, setCalc] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [success, setSuccess] = useState(null);
  const [msg, setMsg] = useState('');
  const [history, setHistory] = useState([]);

  useEffect(() => {
    axios.get('/api/formulas').then(r => setFormulas(r.data)).catch(()=>{});
    axios.get('/api/production').then(r => setHistory(r.data));
  }, []);

  useEffect(() => {
    if (formulaId && qtyPlanned && parseFloat(qtyPlanned) > 0) {
      axios.get(`/api/production/calc?formula_id=${formulaId}&qty_kg=${qtyPlanned}`)
        .then(r => setCalc(r.data));
    } else setCalc([]);
  }, [formulaId, qtyPlanned]);

  const loss = qtyActual && qtyPlanned ? (parseFloat(qtyPlanned) - parseFloat(qtyActual)).toFixed(4) : null;
  const lossPct = loss && qtyPlanned ? ((parseFloat(loss)/parseFloat(qtyPlanned))*100).toFixed(2) : null;

  const handleSubmit = async () => {
    try {
      const { data } = await axios.post('/api/production', {
        formula_id: formulaId, qty_planned: qtyPlanned,
        qty_actual: qtyActual || qtyPlanned, notes
      });
      setSuccess(data);
      setFormulaId(''); setQtyPlanned(''); setQtyActual(''); setNotes(''); setCalc([]);
      axios.get('/api/production').then(r => setHistory(r.data));
    } catch (err) {
      setMsg(err.response?.data?.error || 'เกิดข้อผิดพลาด');
    }
    setConfirm(false);
  };

  return (
    <div>
      {confirm && (
        <ConfirmModal
          title="ยืนยันสั่งผสม"
          body={`ยืนยันการผสม "${formulas.find(f=>f.id==formulaId)?.name}" จำนวน ${qtyPlanned} kg (ได้จริง ${qtyActual||qtyPlanned} kg)?`}
          onConfirm={handleSubmit} onCancel={() => setConfirm(false)}
        />
      )}
      {msg && <div className="alert alert-danger">{msg}</div>}
      {success && (
        <div className="success-banner">
          <span><i className="ti ti-check" style={{ marginRight:6 }}/>ผสมสำเร็จ — Batch {success.batch_no}</span>
          <button className="btn-primary" style={{ fontSize:11,padding:'5px 14px' }} onClick={() => { setSuccess(null); setPage('bottling'); }}>
            ไปบรรจุขวด →
          </button>
        </div>
      )}

      <div className="sh">สั่งผสมน้ำหอม</div>
      <div className="glass-card">
        <div className="grid-2">
          <div className="form-group">
            <label className="fl">เลือกสูตรน้ำหอม</label>
            <select className="fi" value={formulaId} onChange={e => setFormulaId(e.target.value)}>
              <option value="">เลือกสูตร...</option>
              {formulas.map(f => <option key={f.id} value={f.id}>{f.code} · {f.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="fl">ต้องการผสม (kg)</label>
            <input className="fi" type="number" value={qtyPlanned} onChange={e => setQtyPlanned(e.target.value)} placeholder="25"/>
          </div>
        </div>

        {calc.length > 0 && (
          <>
            <div className="divider"/>
            <div className="fl" style={{ marginBottom:8 }}>วัตถุดิบที่ต้องใช้</div>
            <div style={{ background:'#f7f5f2',borderRadius:8,padding:'10px 12px',marginBottom:12 }}>
              {calc.map(c => (
                <div key={c.material_id} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'5px 0',borderBottom:'1px solid #ede9e3',fontSize:12 }}>
                  <span style={{ color:'var(--text-secondary)',fontWeight:500 }}>{c.material_name} <span style={{ fontSize:10,color:'var(--text-muted)' }}>({c.percentage}%)</span></span>
                  <div style={{ display:'flex',alignItems:'center',gap:8 }}>
                    <span style={{ fontWeight:600,color:'var(--text-primary)' }}>{c.qty_needed} {c.unit}</span>
                    <span className={`badge ${c.is_enough?'badge-ok':'badge-err'}`}>{c.is_enough?'พอ':'ไม่พอ'}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="divider"/>
        <div className="grid-2">
          <div className="form-group">
            <label className="fl">ได้จริง (kg)</label>
            <input className="fi" type="number" value={qtyActual} onChange={e => setQtyActual(e.target.value)} placeholder={qtyPlanned || '0'}/>
          </div>
          <div className="form-group">
            <label className="fl">Loss</label>
            <input className="fi" readOnly value={loss ? `${loss} kg (${lossPct}%)` : '—'} style={{ background:'#f7f5f2',color:'var(--text-muted)' }}/>
          </div>
        </div>
        {loss && parseFloat(loss) > 0 && (
          <div className="loss-box">
            <i className="ti ti-info-circle"/>
            ต้นทุน/kg คำนวณตามจำนวนที่ได้จริง ({qtyActual} kg)
          </div>
        )}

        <div className="form-group" style={{ marginTop:12 }}>
          <label className="fl">หมายเหตุ</label>
          <input className="fi" value={notes} onChange={e => setNotes(e.target.value)} placeholder="หมายเหตุ"/>
        </div>

        <div className="btn-row">
          <button className="btn-primary" disabled={!formulaId || !qtyPlanned} onClick={() => setConfirm(true)}>
            ยืนยันสั่งผสม
          </button>
        </div>
      </div>

      <div className="sh">ประวัติการผสม</div>
      <div className="glass-card">
        <table className="tbl">
          <thead><tr><th>Batch</th><th>สูตร</th><th>สั่ง (kg)</th><th>ได้จริง (kg)</th><th>Loss</th><th>โดย</th><th>วันที่</th></tr></thead>
          <tbody>
            {history.map(h => (
              <tr key={h.id}>
                <td style={{ fontFamily:'monospace',fontSize:11,color:'var(--text-muted)' }}>{h.batch_no}</td>
                <td style={{ fontWeight:500 }}>{h.formula_name}</td>
                <td>{parseFloat(h.qty_planned).toFixed(4)}</td>
                <td style={{ fontWeight:600 }}>{parseFloat(h.qty_actual||h.qty_planned).toFixed(4)}</td>
                <td style={{ color:parseFloat(h.loss_qty)>0?'var(--warning)':'var(--text-muted)' }}>{parseFloat(h.loss_qty||0).toFixed(4)} kg</td>
                <td>{h.created_by_name}</td>
                <td>{new Date(h.created_at).toLocaleDateString('th-TH')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
